import { EditorView } from 'codemirror'
import { MatchDecorator, ViewPlugin, Decoration } from '@codemirror/view'


export const getFunctionNameWidget =  (functionKeys) => {
  const functionNameMatcher = new MatchDecorator({
    regexp: new RegExp(functionKeys.join('|'), 'g'),
    decoration: (match) => {
      return Decoration.mark({ class: 'cm-custom-function-name' })
    }
  })

  return ViewPlugin.fromClass(
    class {
      functionNames
      constructor(view) {
        this.functionNames = functionNameMatcher.createDeco(view)
      }
      update(update) {
        this.functionNames = functionNameMatcher.updateDeco(update, this.functionNames)
      }
    },
    {
      decorations: (instance) => instance.functionNames,
      provide: (plugin) =>
        EditorView.atomicRanges.of((view) => {
          return view.plugin(plugin)?.functionNames || Decoration.none
        })
    }
  )
}
